import cx from 'classnames'
import { Link } from 'react-router'
import OptionsDropdown from 'components/shared/OptionsDropdown'
import CopyToClipboard from 'react-copy-to-clipboard'
import { Button, Icon, ToolTip } from '@driftt/tide-core-legacy'

import { MEETING_ICON_TO_DURATION } from '../constants'

const TagWithTooltip = ({ tag, copy }) => (
  <div className="meeting-tag-tooltip">
    <div is tooltip={copy} flow="up">
      <div className="meeting-type-tag">{tag}</div>
    </div>
  </div>
)

const TooltipCopy = {
  ROUTING: 'Meetings created through playbooks will use this meeting type.',
  PROFILE: 'This Meeting is bookable through your Drift Profile.',
}

const MeetingTypeListItem = ({
  router,
  settings,
  isDefault,
  isDeleting,
  profileUrl,
  isCopied,
  handleCopyMeetingLink,
  handleDeleteMeetingType,
  gated = false,
  profileVisibility = false
}) => {
  const meetingLink = `${profileUrl}${isDefault ? '?schedule' : `/${settings.slug}`}`
  const preventClickHandler = (e) => {
    if (gated) {
      e.stopPropagation()
      e.preventDefault()
    }
  }
  const profileIsPrivate = profileVisibility === 'PRIVATE'
  const meetingTypeTooltipContent = profileIsPrivate ? (
    <span>Set your profile privacy to 'public'<br />to share your profile link</span>
  ) : (
    <span>Click to copy your meeting link</span>
  )

  return (
    <div className={cx('settings-meeting-type-list-item', { deleting: isDeleting || gated })}>
      <div className="flex">
        <img className="meeting-type-list-item-icon" src={MEETING_ICON_TO_DURATION[`${settings.duration}`]} />
        <div className="meeting-type-list-item-details">
          <div className={cx({ "meeting-type-list-item-text-wrapper": !isDefault })}>
            <Link
              onClick={preventClickHandler}
              className="meeting-type-title"
              to={`/settings/calendar/edit/${isDefault ? 'default' : settings.slug}`}
            >
              {settings.name}
            </Link>
            <span className="meeting-type-list-item-duration">{settings.duration} min</span>
          </div>
          <div className="meeting-type-list-item-subdetails">
            {isDefault && (
              <div className="flex-space-between">
                <TagWithTooltip tag="Chat" copy={TooltipCopy.ROUTING} />
                <TagWithTooltip tag="Drift Profile" copy={TooltipCopy.PROFILE} />
              </div>
            )}
          </div>
        </div>
      </div>
      {!gated && <div className="meeting-type-list-item-controls">
        {!isDeleting && (
          <div className="meeting-type-list-item-menu">
            <ToolTip
              flow="up"
              component={meetingTypeTooltipContent}
            >
              <CopyToClipboard text={meetingLink} onCopy={handleCopyMeetingLink}>
                <Button className="meeting-link-copy" type="tertiary" disabled={gated || profileIsPrivate}>
                  <Icon className="meeting-link-copy-icon" width={12} name="link-1" />{' '}
                  {isCopied ? 'Copied!' : 'Share this meeting'}
                </Button>
              </CopyToClipboard>
            </ToolTip>
            <div className="meeting-options-dropdown">
              <OptionsDropdown
                handleEditClick={() => {
                  router.push(`/settings/calendar/edit/${isDefault ? 'default' : settings.slug}`)
                }}
                handleDeleteClick={!isDefault && handleDeleteMeetingType}
              />
            </div>
          </div>
        )}
      </div>}
    </div>
  )
}
export default MeetingTypeListItem



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/MeetingTypesListItem/component.js